import { Home, Calendar, Newspaper, Video, Menu } from "lucide-react";
import { cn } from "../lib/utils";
import { useLocation, Link } from "react-router-dom";

export function BottomNav({ onMenuClick }) {
  const location = useLocation();
  
  const items = [
    { icon: Home, label: "Home", href: "/", active: location.pathname === "/" },
    { icon: Calendar, label: "Events", href: "/staff-events", active: location.pathname === "/staff-events" },
    { icon: Newspaper, label: "Info", href: "/information-center", active: location.pathname === "/information-center" },
    { icon: Video, label: "Videos", href: "/videos", active: location.pathname === "/videos" },
    { icon: Menu, label: "More", onClick: onMenuClick },
  ];

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 bg-card border-t border-border z-50">
      <div className="flex items-center justify-around h-16">
        {items.map((item, index) => {
          if (item.onClick) {
            return (
              <button
                key={index}
                onClick={item.onClick}
                className={cn(
                  "flex flex-col items-center justify-center gap-1 px-3 py-2 rounded-lg transition-colors flex-1",
                  item.active ? "text-primary" : "text-muted-foreground"
                )}
              >
                <item.icon className="size-5" />
                <span className="text-xs">{item.label}</span>
              </button>
            );
          }
          return (
            <Link
              key={index}
              to={item.href}
              className={cn(
                "flex flex-col items-center justify-center gap-1 px-3 py-2 rounded-lg transition-colors flex-1",
                item.active ? "text-primary" : "text-muted-foreground"
              )}
            >
              <item.icon className="size-5" />
              <span className="text-xs">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
